module.exports = __webpack_public_path__ + "static/media/girl-25.ed1b0a12.svg";